import React from 'react';
import { ChevronLeftIcon, BookmarkIcon } from 'lucide-react';
import { chaptersContent } from '../data/content';
interface ReaderProps {
  activeChapter: string | null;
  closeReader: () => void;
  showToast: (msg: string) => void;
}
export function Reader({
  activeChapter,
  closeReader,
  showToast
}: ReaderProps) {
  if (!activeChapter) return null;
  const chapter = chaptersContent[activeChapter];
  if (!chapter) return null;
  return <div className="fixed inset-0 bg-bg-main z-[150] flex flex-col max-w-[430px] mx-auto animate-fade-in" data-id="element-34">
      <div className="bg-white px-5 py-4 flex items-center gap-3.5 sticky top-0 z-[100] shadow-[0_1px_0_rgba(0,0,0,0.06)]" data-id="element-35">
        <button onClick={closeReader} className="w-9 h-9 rounded-xl bg-cream flex items-center justify-center transition-transform active:scale-95" data-id="element-36">
          <ChevronLeftIcon className="w-5 h-5 text-text-dark" data-id="element-37" />
        </button>
        <div className="flex-1 text-base font-bold text-text-dark truncate" data-id="element-38">
          {chapter.title}
        </div>
        <button onClick={() => showToast('Bookmarked!')} className="w-9 h-9 rounded-xl bg-cream flex items-center justify-center transition-transform active:scale-95" data-id="element-39">
          <BookmarkIcon className="w-4 h-4 text-text-dark" data-id="element-40" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto px-5 py-6 pb-24" data-id="element-41">
        {chapter.content}
      </div>
    </div>;
}